/**
 * Truncate a markup string at a byte cap without leaving an open tag.
 *
 * We always trim back to just after the previous `>` so the returned string
 * ends on a tag boundary. If the cap falls inside a tag, this protects the
 * downstream parser; if it falls inside text content, we drop the dangling
 * text rather than leave loose characters between tags. Open elements are
 * NOT auto-closed — the fade overlay hides the bottom anyway.
 */
export function capMarkup(input: string, cap: number): string {
  if (input.length <= cap) return input;
  const head = input.slice(0, cap);
  const lastGt = head.lastIndexOf('>');
  return lastGt >= 0 ? head.slice(0, lastGt + 1) : '';
}
